// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { AssetPreferencesPanel } from '#components/domain/operations/assets/asset-preferences/asset-preferences-panel.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/asset-preferences')({
    component: AssetPreferencesPanel,
})
